import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { PurpleButton } from "../../components/buttons/purpleButton";
import { ImageUpload } from "../../components/imageUpload";
import { TextBox } from "../../components/textBox";
import publicidadesService from "../../services/publicidadesService";
import { scrollUp } from "../../utils/pageUtils";
import { IPublicidades } from "./../../Interfaces/model/iPublicidade";
import {
  Container,
  DivAdsSloteMobile,
  DivAdsSloteWeb,
  DivDefault,
  DivImageAds,
  DivTitle,
  HomeAdsDiv,
  LinkAndSubmit,
} from "./style";

const TOAST_SUMMARIES = {
  error: "Erro",
  success: "Sucesso",
  warn: "Atenção",
} as const;

export const PostAds = () => {
  const toast = useRef<Toast>(null);
  const [adsList, setAdsList] = useState<IPublicidades[]>([]);
  const [selectedName, setSelectedName] = useState<string>("");
  const [selectedImageWeb, setSelectedImageWeb] = useState<string>("");
  const [selectedImageMobile, setSelectedImageMobile] = useState<string>("");
  const [selectedLink, setSelectedLink] = useState<string>("");
  const [isWebImageUploading, setIsWebImageUploading] = useState(false);
  const [isMobileImageUploading, setIsMobileImageUploading] = useState(false);
  const isImageUploading =
    isWebImageUploading || isMobileImageUploading;

  useEffect(() => {
    scrollUp();
    publicidadesService
      .getAllAds()
      .then((res) => {
        setAdsList(res.data);
      })
      .catch(() => {
        toastMessage("Falha ao obter ads", "error");
      });
  }, []);

  const handleUpdateAds = () => {
    if (isImageUploading) {
      toastMessage("Aguarde o envio das imagens antes de atualizar.", "warn");
      return;
    }

    if (selectedAds?.id === undefined) {
      toastMessage("Selecione um anúncio válido.", "error");
      return;
    }

    const data: IPublicidades = {
      nome: selectedAds.nome,
      imagemWeb: selectedImageWeb || selectedAds.imagemWeb,
      recomendadoWeb: selectedAds.recomendadoWeb,
      imagemMobile: selectedImageMobile || selectedAds.imagemMobile,
      recomendadoMobile: selectedAds.recomendadoMobile,
      linkUrl: selectedLink.trim() || selectedAds.linkUrl,
    };

    publicidadesService
      .putAds(selectedAds.id, data)
      .then((res) => {
        if (res.status === 200) {
          setAdsList((current) =>
            current.map((ads) =>
              ads.id === selectedAds.id ? { ...ads, ...data } : ads
            )
          );
          toastMessage("Ads atualizado com sucesso", "success");
        }
      })
      .catch(() => toastMessage("Falha ao atualizar ads.", "error"));
  };

  const selectedAds = adsList.find((ads) => ads.nome === selectedName);
  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const name = e.target.value;
    setSelectedName(name);
    const ads = adsList.find((item) => item.nome === name);
    setSelectedImageWeb(ads?.imagemWeb ?? "");
    setSelectedImageMobile(ads?.imagemMobile ?? "");
    setSelectedLink(ads?.linkUrl ?? "");
  };

  function toastMessage(
    message: string,
    type: "error" | "success" | "warn"
  ) {
    toast.current?.show({
      severity: type,
      summary: TOAST_SUMMARIES[type],
      detail: message,
      life: 3000,
    });
  }

  return (
    <>
      <Toast ref={toast} />
      <Container>
        <HomeAdsDiv>
          <DivTitle>
            <h1 style={{ color: "#fff" }}>Adicionar Ads</h1>
            <select
              value={selectedName}
              disabled={isImageUploading}
              onChange={handleSelectChange}
            >
              <option value="">Selecionar</option>
              {adsList.map((ads) => (
                <option key={ads.id} value={ads.nome}>
                  {ads.nome}
                </option>
              ))}
            </select>
          </DivTitle>
          <DivImageAds>
            {selectedAds ? (
              <>
                <DivAdsSloteWeb>
                  <h2 style={{ color: "#fff" }}>Imagem Web</h2>
                  <h4
                    style={{ color: "#fff" }}
                  >{`Recomendado: ${selectedAds.recomendadoWeb}`}</h4>
                  <ImageUpload
                    value={selectedImageWeb}
                    onChange={setSelectedImageWeb}
                    category="ADS"
                    contentId={selectedAds.id}
                    label=""
                    onUploadingChange={setIsWebImageUploading}
                  />
                </DivAdsSloteWeb>
                <DivAdsSloteMobile>
                  <h2 style={{ color: "#fff" }}>Imagem Mobile</h2>
                  <h4
                    style={{ color: "#fff" }}
                  >{`Recomendado: ${selectedAds.recomendadoMobile}`}</h4>
                  <ImageUpload
                    value={selectedImageMobile}
                    onChange={setSelectedImageMobile}
                    category="ADS"
                    contentId={selectedAds.id}
                    label=""
                    onUploadingChange={setIsMobileImageUploading}
                  />
                </DivAdsSloteMobile>
              </>
            ) : (
              <DivDefault>
                <p>Selecione um Ads</p>
              </DivDefault>
            )}
          </DivImageAds>
          {selectedAds && (
            <LinkAndSubmit>
              <TextBox
                title="Digite o novo link do anunciante"
                value={selectedLink}
                onChangeText={setSelectedLink}
                height="48px"
              />
              <div style={{ margin: "16px" }} />
              <PurpleButton
                title="Atualizar"
                disabled={isImageUploading}
                onClick={handleUpdateAds}
              />
            </LinkAndSubmit>
          )}
        </HomeAdsDiv>
      </Container>
    </>
  );
};
